import type { CSSProperties, ReactNode } from 'react';

interface LogoProps {
  /** Variante a renderizar. */
  variant?: 'full' | 'icon' | 'icon-white';
  /** Altura en px. Width se calcula manteniendo aspect ratio. */
  size?: number;
  /** Estilo CSS adicional (margin, etc.). */
  className?: string;
  /** Alt text para accesibilidad. */
  alt?: string;
}

/**
 * Logo oficial Things360. Variantes:
 * - `full`: logotipo horizontal (texto + bola) — para navbar / login.
 * - `icon`: solo la bola (color teal corporativo) — para usos compactos.
 * - `icon-white`: bola en blanco — para fondos oscuros.
 */
export function Logo({
  variant = 'full',
  size = 32,
  className = '',
  alt = 'Things360',
}: LogoProps): ReactNode {
  const src =
    variant === 'icon'
      ? '/logo-icon.png'
      : variant === 'icon-white'
        ? '/logo-icon-white.png'
        : '/logo.png';

  // Aspect ratios reales tras trimming (mantienen las proporciones del PNG).
  // full ~ 2.78:1   icon ~ 1:1
  const style: CSSProperties =
    variant === 'full'
      ? { height: `${size}px`, width: 'auto' }
      : { height: `${size}px`, width: `${size}px` };

  return <img src={src} alt={alt} style={style} className={className} />;
}
